import Vue from 'vue'
import App from './App.vue'
import router from "./router"
import store from './stores/index';
/* 全局引入element  */
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import GlobalComponents from '@/plugins/global-components' // 导入插件
Vue.use(ElementUI);
Vue.use(GlobalComponents);
/* 局部引入 */
import "../plugins/element"
import 'jquery'
// 引入ant
// import Antd from 'ant-design-vue';
// import 'ant-design-vue/dist/antd.css';
// 引入echarts
import * as echarts from 'echarts'

import axios from 'axios'


// Vue.use(Antd);
Vue.config.productionTip = false
Vue.prototype.axios=axios//挂载到原型上，可以在全局使用
Vue.prototype.$echarts = echarts
// axios.defaults.baseURL = process.env.NODE_ENV == "development" ? '/api' : process.env.VUE_APP_API_BASE_URL;

new Vue({
  render: h => h(App),
  router:router,
  store
}).$mount('#app')
